export default "269d07ca4f539a52.svg"